import DOMPurify from 'dompurify';

/**
 * Sanitize HTML before it is handed to dangerouslySetInnerHTML.
 *
 * The opportunity summary and agent output are LLM-generated from
 * third-party solicitation text (adversary-influenceable via prompt
 * injection), so they must never be trusted as raw HTML. DOMPurify strips
 * scripts, event handlers, and javascript: URLs; we additionally forbid
 * inline styles and forms to remove CSS/exfil vectors, and force safe
 * rel/target on any links.
 */
export function sanitizeHtml(dirty: unknown): string {
  if (typeof dirty !== 'string' || !dirty) return '';
  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'form', 'input', 'button', 'iframe', 'object', 'embed'],
    FORBID_ATTR: ['style'],
  });
}
